<template>
  <div class="registration-header">
    <div class="registration-header-steps">
      <Steps :current="current">
        <Step
          v-if="data.guide && data.guide.enableFlag"
          :title="$t('global.guide')"
        ></Step>
        <Step :title="$t('global.text21')"></Step>
        <Step
          v-if="data.attachments && data.attachments.length"
          :title="$t('global.text22')"
        ></Step>
      </Steps>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({
        attachments: []
      })
    },
    current: {
      type: Number,
      default: 0
    }
  }
};
</script>

<style scoped lang="less">
.registration {
  &-header {
    background-color: #fff;
    height: 56px;
    align-items: center;
    justify-content: center;
    display: flex;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 100;
    box-shadow: 0px 2px 20px 0px rgba(11, 4, 84, 0.08);

    &-steps {
      width: 556px;
      text-align: left;
    }
  }
}

:deep(.ivu-steps) {
  .ivu-steps-item {
    .ivu-steps-tail {
      display: none !important;
    }
  }
}
</style>
